import * as ScrollArea from '@radix-ui/react-scroll-area'
import styled from '@emotion/styled'
import { colors } from '@/constants'
import { ReactNode } from 'react'

const StyledScrollArea = styled(ScrollArea.Root)<{
  maxHeight?: number
}>`
  width: 100%;
  height: ${({ maxHeight }) =>
    maxHeight !== undefined ? `${maxHeight}px` : 'auto'};
  border-radius: 4px;
  overflow: hidden;
`

const StyledViewport = styled(ScrollArea.Viewport)`
  width: 100%;
  height: 100%;
  border-radius: inherit;
`

const StyledScrollbar = styled(ScrollArea.Scrollbar)`
  display: flex;
  user-select: none;
  touch-action: none;
  padding: 2px;
  background: ${colors.darkBlue2};
  transition: background 160ms ease-out;

  &[data-orientation='vertical'] {
    width: 8px;
  }

  &:hover {
    background: ${colors.darkBlue3};
  }
`

const StyledThumb = styled(ScrollArea.Thumb)`
  flex: 1;
  background: ${colors.grey400};
  border-radius: 4px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    min-width: 44px;
    min-height: 44px;
  }
`

const ScrollContainer = styled.div<{ maxHeight?: number }>`
  max-height: ${({ maxHeight }) =>
    maxHeight !== undefined ? `${maxHeight}px` : 'auto'};
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
`

export function ScrollableArea({
  maxHeight,
  shouldScroll,
  children,
  className,
}: {
  maxHeight?: number
  shouldScroll?: boolean
  children?: ReactNode
  className?: string
}) {
  return (
    <ScrollContainer maxHeight={maxHeight} className={className}>
      <StyledScrollArea maxHeight={maxHeight}>
        <StyledViewport>{children}</StyledViewport>
        {shouldScroll && (
          <StyledScrollbar orientation="vertical">
            <StyledThumb />
          </StyledScrollbar>
        )}
      </StyledScrollArea>
    </ScrollContainer>
  )
}
